import { Breadcrumb, Flex, Row, Space } from "antd";
import { MainLayout } from "components/layouts";
import AttendanceMenu from "./AttendanceTabMenu";

import styles from "../styles/Attendance.module.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const AttendanceSetting = ({
  getPage = () => { },
  handleMenuChange = () => { },
  selectedMenu = []
}) => {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  const menuBreadcrumbMapping = {
    'working': t('workin_location.header'),
    'holiday': t('holiday.header'),
    'leave': t('leave_type.header'),
    'shifts': t('shift.header'),
    'workflow': t('workflow.header'),
    'bePerform': t('besmart_Perfrom.header'),
    'configBesmart': t('configBesmart.config_Besmart')
  }

  return (
    <MainLayout>
      <Flex vertical style={{ rowGap: 40 }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "" },
            { title: t("attendance_setting.header"), href: "" },
            { title: menuBreadcrumbMapping[selectedMenu] || null }
          ]} />
          <h2>{menuBreadcrumbMapping[selectedMenu] || t("attendance_setting.entity")}</h2>
        </Flex>
        {(roles.some(role => role.startsWith("ACCESS_CONFIGURATION|ATTENDANCE_SETTING"))) &&
          (<Space className={styles.container} size={24} direction="vertical">
            <AttendanceMenu selectedKeys={selectedMenu} onChange={handleMenuChange} />
            <Row>
              {getPage()}
            </Row>
          </Space>)}
      </Flex>

    </MainLayout>
  );
};

export default AttendanceSetting;
